import { AbstractService } from '@uniqoders/sdk';

export default class FaqService extends AbstractService {
  /**
   * Retrieve paginated FAQs for an agency
   */
  public listCmsFaqs(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/faqs', { agency }),
      params,
    });
  }

  /**
   * Retrieve a single FAQ
   */
  public getCmsFaq(agency: string, cmsFaqId: number, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/faqs/{cmsFaqId}', { agency, cmsFaqId }),
      params,
      headers,
    });
  }

  /**
   * Create a new FAQ
   */
  public createCmsFaq(agency: string, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/faqs', { agency }),
      data,
    });
  }

  /**
   * Update an existing FAQ
   */
  public updateCmsFaq(agency: string, cmsFaqId: number, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/faqs/{cmsFaqId}', { agency, cmsFaqId }),
      data,
    });
  }

  /**
   * Delete a FAQ
   */
  public deleteCmsFaq(agency: string, cmsFaqId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/faqs/{cmsFaqId}', { agency, cmsFaqId }),
    });
  }

  /**
   * Publish or unpublish a FAQ
   */
  public publishCmsFaq(
    agency: string,
    cmsFaqId: number,
    data: { is_public: boolean },
  ): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/faqs/{cmsFaqId}/publish', { agency, cmsFaqId }),
      data,
    });
  }
}

